import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import RouteToggle from 'components/RouteToggle';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { AppBar, Toolbar, Hidden } from '@material-ui/core';
import { URL_HELPERS } from 'helpers/url';
import ConnectWallet from 'components/ConnectWallet';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: '#000',
    borderBottom: '1px solid #000',
  },
  flexGrow: {
    flexGrow: 1,
  },
  buttons: {
    color: theme.palette.primary.main,
  },
  logoMobileLink: {
    flex: 1,
    textAlign: 'center',
  },
  logoMobile: {
    flex: 1,
    width: 80,
  },
  logo: {
    width: 90,
  },
  toolbar: {
    position: 'relative',
  },
  toggle: {
    width: '100%',
    display: 'flex',
    position: 'absolute',
  },
}));

const Topbar = props => {
  const { className } = props;

  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)}>
      <Toolbar className={classes.toolbar}>
        <Hidden smDown>
          <RouterLink to={URL_HELPERS.home}>
            <img alt="Logo" className={classes.logo} src="/images/logo.png" />
          </RouterLink>
          <div className={classes.flexGrow} />
          {/* <RouteToggle /> */} {/* Update back */}
        </Hidden>
        <Hidden mdUp>
          <RouterLink to={URL_HELPERS.home} className={classes.logoMobileLink}>
            <img
              alt="Logo"
              className={classes.logoMobile}
              src="/images/logo.png"
            />
          </RouterLink>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
};

export default withRouter(Topbar);
